export enum LoadingState {
    IDLE = 'IDLE',
    LOADING = 'LOADING',
    FAILED = 'FAILED',
    DONE = 'DONE'
}
